import { Activity, useEffect, useState } from 'react'
import HeaderEmbed from '@common/HeaderEmbed'
import '@common/reset.css'
import './style.scss'
import Home from './components/Home'
import Noticia from './components/Noticia'

export default function App({ lang, preview, embedHome }) {
	/**************************/
	// Si cal afegir dades del CMS
	const [dadesCMS, setDadesCMS] = useState(null)

	useEffect(() => {
		const fetchData = async () => {
			try {
				const res = await fetch(`${process.env.API_CLIENT}/embeds/v1/grossa-diada`)
				const json = await res.json()
				setDadesCMS(json.data)
			} catch (error) {
				console.log(error)
			}
		}

		fetchData()
	}, [])
	/**************************/

	if (!dadesCMS) return null

	return (
		<>
			<Activity mode={preview ? 'visible' : 'hidden'}>
				<HeaderEmbed allowHomeEmbed />
			</Activity>
			<Home dadesCMS={dadesCMS} />
			<Activity mode={embedHome ? 'hidden' : 'visible'}>
				<Noticia dadesCMS={dadesCMS} />
			</Activity>
		</>
	)
}
